(function() {
  var urllite;

  urllite = require('./core');

  require('./extensions/resolve');

  require('./extensions/relativize');

  require('./extensions/normalize');

  require('./extensions/toString');

  module.exports = urllite;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./node_modules/urllite/lib/complete.js
// module id = 831
// module chunks = 0